import { SET_PLAID_HANDLER } from "state/actions/plaid";
import createReducer from "./createReducer";

export default createReducer<any>({ successType: SET_PLAID_HANDLER });
